import { uniqueString } from '../utils/string'

const _data = uniqueString('PriorityQueue_data')
const _priority = uniqueString('PriorityQueue_priority')
const _queue = uniqueString('PriorityQueue_queue')

export class PriorityQueueItem {
  constructor(data = {}, priority = 9) {
    this[_data] = data
    this[_priority] = priority
  }

  get data() {
    return this[_data]
  }

  get priority() {
    return this[_priority]
  }
}

export default class PriorityQueue {
  constructor() {
    this[_queue] = []
  }

  get size() {
    return this[_queue].length
  }

  get empty() {
    return this[_queue].length === 0
  }

  get front() {
    return this[_queue][0] ? this[_queue][0].data : null
  }

  enqueue(element, priority = 9) {
    if (priority < 1) priority = 1
    else if (priority > 9) priority = 9

    const queueItem = new PriorityQueueItem(element, priority)
    const queue = this[_queue]

    if (this.empty) {
      this[_queue].push(queueItem)
    } else {
      let added = false

      for (let i = 0; i < queue.length; ++i) {
        if (priority < queue[i].priority) {
          queue.splice(i, 0, queueItem)

          added = true

          break
        }
      }

      if (!added) this[_queue].push(queueItem)
    }
  }

  dequeue() {
    if (this.empty) return

    return this[_queue].shift().data
  }

  clear() {
    this[_queue] = []
  }
}
